<div class="vera-page">
	<aside class="vera-convo-list">
		<div class="vera-convo-list-hdr">
			<div class="vera-convo-list-title">Conversations</div>
		</div>
		<button class="vera-new-btn" type="button" (click)="startNewConversation()">
			<i class="bx bx-edit-alt"></i>
			New conversation
		</button>
		<div class="vera-convo-items">
			<div
				class="vera-convo-item"
				*ngFor="let conversation of conversations; trackBy: trackByIndex"
				[class.active]="conversation.id === activeConversationId"
				[class.editing]="renamingConversationId === conversation.id"
				(click)="selectConversation(conversation.id)"
			>
				<input
					*ngIf="renamingConversationId === conversation.id; else viewTitle"
					class="vera-convo-rename-input"
					type="text"
					[(ngModel)]="renameDraft"
					name="renameDraft"
					autofocus
					(click)="$event.stopPropagation()"
					(keydown.enter)="confirmRename(conversation)"
					(keydown.escape)="cancelRename()"
					(blur)="confirmRename(conversation)"
				/>
				<ng-template #viewTitle>
					<div class="vera-convo-item-title">{{ conversationTitle(conversation) }}</div>
				</ng-template>
				<div class="vera-convo-item-actions" *ngIf="renamingConversationId !== conversation.id">
					<button class="vera-convo-action" type="button" title="Rename" (click)="startRename(conversation, $event)">
						<i class="bx bx-pencil"></i>
					</button>
					<button class="vera-convo-action vera-convo-delete" type="button" title="Delete" (click)="deleteConversation(conversation, $event)">
						<i class="bx bx-trash"></i>
					</button>
				</div>
			</div>
			<div class="vera-convo-empty" *ngIf="!loadingConversations && conversations.length === 0">You don't have any conversations with Vera yet.</div>
		</div>
	</aside>

	<section class="vera-chat-pane">
		<div class="vera-chat-hdr">
			<div class="vera-chat-hdr-title">Vera AI</div>
			<div class="vera-chat-hdr-sub" *ngIf="activeConversation">{{ conversationTitle(activeConversation) }}</div>
		</div>

		<div class="vera-msgs">
			<div class="vera-msg" *ngFor="let m of messages; trackBy: trackByIndex" [class.user]="m.role === 'user'" [class.assistant]="m.role === 'assistant'">
				<div class="vera-bubble" [innerHTML]="render(m.text)"></div>
				<div class="vera-options" *ngIf="m.options?.length">
					<button
						class="vera-option-btn"
						*ngFor="let option of m.options"
						(click)="selectOption(m, option)"
						[disabled]="loading || m.optionsResolved"
						type="button"
					>
						{{ optionLabel(option) }}
					</button>
				</div>
				<div class="vera-msg-time">{{ m.time }}</div>
			</div>
			<div class="vera-msg assistant" *ngIf="loading">
				<div class="vera-typing"><span></span><span></span><span></span></div>
			</div>
			<div #messagesEnd></div>
		</div>

		<div class="vera-chips" *ngIf="messages.length <= 1">
			<div class="vera-chip" *ngFor="let chip of suggestionChips" (click)="sendChip(chip)">{{ chip }}</div>
		</div>

		<div class="vera-input-row">
			<textarea
				class="vera-input"
				rows="1"
				placeholder="Ask Vera..."
				[(ngModel)]="draft"
				name="veraDraft"
				(keydown)="onInputKeydown($event)"
			></textarea>
			<button class="vera-send" (click)="send()" [disabled]="loading || !draft.trim()" type="button">↑</button>
		</div>
	</section>
</div>
